import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Events } from "../../helpers/events";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-attendee-filter',
    templateUrl: './attendee-filter.component.html',
    styleUrls: ['./attendee-filter.component.scss'],
})
export class AttendeeFilterComponent implements OnInit {

    @Input() likes: boolean;
    @Input() bookmarks: boolean;
    @Input() order: string;
    @Input() matchingOrderAllowed: boolean = true;
    @Input() limitedMemberList: boolean = false

    public env = environment;

    constructor(
        public appEvents: Events,
        private popoverController: PopoverController
    ) { }

    ngOnInit() { }

    filterChanged() {
        this.appEvents.publish('attendee:filter', {
            likes: this.likes,
            bookmarks: this.bookmarks,
            order: this.order,
        });
        this.DismissClick();
    }

    async DismissClick() {
        await this.popoverController.dismiss({
            likes: this.likes,
            bookmarks: this.bookmarks,
            order: this.order,
        });
    }

}
